<template>
  <div class="u-text-align-center u-locked-view u-padding-top u-padding-bottom">
    <img width="125" src="@/assets/images/locked.svg" alt="locked svg" />

    <div class="u-margin-top">{{ $t("common.lockedView") }}</div>
    <div class="u-margin-top-small">
      <small> <slot></slot> </small>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style></style>
